export default __webpack_public_path__ + "5306fe0e46ff4d7db4702f6c117f71ec.webp";